import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

export default function Login() {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="bg-white dark:bg-gray-800 rounded shadow-lg p-8 max-w-md w-full mx-4">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">GBMEx</h1>
          <p className="text-gray-600 dark:text-gray-400">Global Building Materials Exchange</p>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Sign in to access the RFQ platform, manage quotes, and communicate with dealers.
          </p>

          <button
            onClick={() => loginWithRedirect()}
            className="w-full bg-gray-800 dark:bg-gray-700 hover:bg-gray-700 dark:hover:bg-gray-600 text-white font-medium py-3 px-4 rounded transition-colors"
          >
            Sign In
          </button>
        </div>

        <div className="border-t border-gray-200 dark:border-gray-700 pt-6">
          <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
            <li>• Submit and manage RFQs</li>
            <li>• Real-time quote notifications</li>
            <li>• Chat with dealers</li>
            <li>• Track RFQ history and archive</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
